import { render } from "./ConfirmSignupCodeView.vue?vue&type=template&id=18b5bcde&scoped=true"
import script from "./ConfirmSignupCodeView.vue?vue&type=script&lang=js"
export * from "./ConfirmSignupCodeView.vue?vue&type=script&lang=js"

import "./ConfirmSignupCodeView.vue?vue&type=style&index=0&id=18b5bcde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b5bcde"]])

export default __exports__